export const ACTION_TYPE_ENTER_FORM_DETAILS = "ENTER_FORM_DETAILS";
